module.exports = __webpack_public_path__ + "static/austin-e07a3141e60da130ab380d743f913b5b.png";